// Helper function to get the display text for a credit rating category
export const getCategoryDisplayText = (category: string, t: (key: string) => string): string => {
	switch (category) {
		case 'missing':
			return `- ${t('default.isMissing')}`;
		case 'other':
			return t('default.other');
		default:
			return category;
	}
};

// Helper function to get the numeric rating display value
export const getNumericRatingDisplay = (numericRating: number | null | undefined, category: string): number | null => {
	if (numericRating == null || category === 'other') {
		return null;
	}

	return numericRating < 0 ? 0 : numericRating;
};

// Helper function to get the text color based on monitoring status
export const getTextColor = (isDeMonitored: boolean): 'grey-11' | 'white' => {
	return isDeMonitored ? 'grey-11' : 'white';
};
